import type { InternalAxiosRequestConfig } from "axios";
import axios from "axios";

export const TOKEN_STORAGE_KEY = "token_my_periocare";

export const setToken = (newToken: string) => {
  localStorage.setItem(TOKEN_STORAGE_KEY, newToken);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
};

const tokenRequestSetup = (axiosConfig: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);

  if (token) {
    axiosConfig.headers.Authorization = `Bearer ${token}`;
  }

  return axiosConfig;
};

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});
api.interceptors.request.use(tokenRequestSetup);
export default api;
